import React from 'react';
import './AnimatedBackground.css';

const AnimatedBackground = () => {
  return (
    <div className="animated-background">
      <div className="mesh-blob blob1" />
      <div className="mesh-blob blob2" />
      <div className="mesh-blob blob3" />
    </div>
  );
};

export default AnimatedBackground;
